<template>
    <div>

        <h1 class="w-full p-2 bg-aitems-700 text-gray-100 font-light tracking-wide">
            Storia Arpa
        </h1>

        <section class="w-2/3 mx-auto mt-5">
            <label for="serial" class="px-6 py-7">
                Numero di Serie:
            </label>
            <input type="text"
                   name="serial"
                   class="w-1/2 border rounded text-lg px-6 py-4 font-bold text-center"
                   v-model="serial"
                   @keyup.enter="fetch"
            >
        </section>
        <section class="mt-5 w-11/12 table mx-auto rounded border shadow-lg" v-if="harp.length > 0">
            <div class="th tr">
                <div class="td">Data</div>
                <div class="td" style="flex-grow: 2">Fase</div>
                <div class="td" style="flex-grow: 2">Dscr. Fase</div>
                <div class="td">Config.</div>
                <div class="td" style="flex-grow: 2">Descrizione</div>
                <div class="td">Magazzino</div>
                <div class="td" style="flex-grow: 2">Causale</div>
                <div class="td"># Ordine Produzione</div>
                <div class="td"># Doc. Vendita</div>
                <div class="td" style="flex-grow: 2">Ragione Sociale</div>
            </div>
            <div class="row" v-for="step in harp">
                <div class="tr">
                    <div class="td">{{ step.data }}</div>
                    <div class="td" style="flex-grow: 2">{{ step.cod_articolo }}</div>
                    <div class="td" style="flex-grow: 2">{{ step.des_articolo }}</div>
                    <div class="td">{{ step.cod_config }}</div>
                    <div class="td" style="flex-grow: 2">{{ step.des_config }}</div>
                    <div class="td">{{ step.magazzino }}</div>
                    <div class="td" style="flex-grow: 2">{{ step.des_causale }}</div>
                    <div class="td">{{ step.ord_produzione }}</div>
                    <div class="td">{{ step.doc_vendita }}</div>
                    <div class="td" style="flex-grow: 2">{{ step.ragione_sociale }}</div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    export default {

        data() {
            return {
                serial: '',
                harp: {},
                details: {},
                domain: process.env.MIX_API_DOMAIN
            }
        },

        methods: {
            fetch() {
                this.$toastr.i("Stiamo cercando l'arpa");
                axios.get(`${this.domain}/produzione/harps/history/single/${this.serial}`)
                    .then(({data}) => {
                        this.$toastr.removeByType("info");
                        if (data.data.length === 0) {
                            this.$toastr.e("Non abbiamo trovato l'arpa :(");
                            return;
                        }
                        this.harp = data.data;
                    });
            }
        }

    }
</script>

